export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/car_wraps.b1a55e6.svg";